import { getDataInconsistency } from '@/services/dataInconsistency';
export const fetchDataInconsistency = () => getDataInconsistency().then(response => formatAvailableTables(response?.data));
const formatAvailableTables = (response) => ({
    data: response?.data,
    errors: response?.errors,
    success: response?.success,
    status: response?.status,
    series: response?.series,
    totalCount: response?.totalCount,
    lastUpdate: response?.lastUpdate,
});
// export data inconsistency
export const exportDataInconsistency = (fileType, responseType) => getDataInconsistency(fileType, responseType).then(response => formatExport(response?.data));
const formatExport = (response) => response;
